import * as path from "path";
import * as fs from "fs";
import { PackageService } from "namirasoft-core";

export class BaseStorage
{
    private config_path: string;
    constructor()
    {
        let pkg = PackageService.getMain();
        this.config_path = path.join(process.env.HOME ?? process.env.USERPROFILE ?? "", `.${pkg.getName()}.config`);
    }
    protected get(): any
    {
        try
        {
            const configFile = fs.readFileSync(this.config_path);
            return JSON.parse(configFile + "");
        } catch (error)
        {
            return {};
        }
    }
    protected set(item: any)
    {
        fs.writeFileSync(this.config_path, JSON.stringify(item));
    }
    getItem(names: string, errorMessage?: string): any | undefined
    {
        let toks = names.split('.');
        let ans = this.get();
        for (let i = 0; i < toks.length; i++)
            if (ans)
                ans = ans[toks[i]];
            else
                ans = undefined;
        if (errorMessage)
            if (ans == null)
                throw new Error(errorMessage);
        return ans;
    }
    setItemByHandler<T>(names: string, handler: (root: any, name: string) => T): T
    {
        let root = this.get();
        let ans = root;
        let toks = names.split('.');
        for (let i = 0; i < toks.length - 1; i++)
        {
            if (!ans[toks[i]])
                ans[toks[i]] = {};
            ans = ans[toks[i]];
        }
        let item = handler(ans, toks[toks.length - 1]);
        this.set(root);
        return item;
    }
    setItem(names: string, value: any | undefined): void
    {
        this.setItemByHandler(names, (ans, name) =>
        {
            if (value == undefined)
                delete ans[name];
            else
                ans[name] = value;
        });
    }
    getCred(names: string): { username: string, password: string } 
    {
        let ans = this.getItem(names);
        if (!ans)
            ans = { username: "", password: "" };
        return { username: ans.username, password: ans.password };
    }
    setCred(names: string, username: string, password: string): void
    {
        this.setItemByHandler(names, (ans, name) =>
        {
            if (!ans[name])
                ans[name] = {};
            ans[name].username = username;
            ans[name].password = password;
        });
    }
    delCred(name: string): void
    {
        this.setItem(name, undefined);
    }
    getNSAToken(): string 
    {
        return this.getItem("account.token",
            "Token is not available. Please login first using:\nns-{project} account config \nor \nns-{project} account login."
        );
    }
    setNSAToken(token: string | undefined): void
    {
        this.setItem("account.token", token);
    }
}